import Card from './card';
import CardGrid from './grid';
var CardExport = Card;
CardExport.Grid = CardGrid;
export * from './interface';
export default CardExport;